<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">招标异常终止</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加异常信息</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
                
            </div>
        </div>

        <div class="table-section">
                <el-table :data="tableData" v-loading="loading" style="width: 100%" :show-header="true" border
                    class="termination-table">
                    <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                    </el-table-column>
                    <el-table-column prop="bidSectionName" label="标段名称" align="center" header-align="center"
                        min-width="150" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="bidSectionCode" label="标段编号" align="center" header-align="center"
                        min-width="180" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="abnormalTypeText" label="异常类型" align="center" header-align="center"
                        min-width="120">
                    </el-table-column>
                    <el-table-column prop="approvalTime" label="审核时间" align="center" header-align="center"
                        min-width="160">
                    </el-table-column>
                    <el-table-column prop="approvalResult" label="审核结果" align="center" header-align="center"
                        min-width="120" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="statusText" label="状态" align="center" header-align="center" min-width="100">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="center" header-align="center" width="150">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status === 0" type="text" size="small"
                                @click="handleDelete(scope.row)">
                                删除
                            </el-button>
                            <el-button v-if="scope.row.status === 1" type="text" size="small"
                                @click="handleViewDetail(scope.row)">
                                查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

            <!-- 分页区域 -->
            <div class="pagination-section">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination" />
            </div>
        </div>

        <!-- 招标异常终止信息弹窗 -->
        <el-dialog :title="isViewMode ? '查看异常终止详情' : '招标异常终止信息'" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" class="termination-dialog">
            <el-form :model="form" :rules="rules" ref="terminationForm" label-width="120px">
                <el-form-item label="标段名称" prop="bidSectionCode" required>
                    <el-select v-model="form.bidSectionCode" placeholder="请选择标段" style="width: 100%"
                        @change="handleSectionChange" :disabled="isViewMode">
                        <el-option v-for="item in bidSectionList" :key="item.bidSectionCode"
                            :label="item.bidSectionName" :value="item.bidSectionCode">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="招标异常类型" prop="abnormalType" required>
                    <el-select v-model="form.abnormalType" placeholder="请选择招标异常类型" style="width: 100%" :disabled="isViewMode">
                        <el-option label="重新招标" :value="1"></el-option>
                        <el-option label="终止招标" :value="2"></el-option>
                        <el-option label="变更招标方式" :value="3"></el-option>
                        <el-option label="重新评标" :value="4"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="异常情况描述" prop="abnormalContent" required>
                    <el-input type="textarea" v-model="form.abnormalContent" placeholder="请输入异常情况描述" :rows="2"
                        resize="vertical" :disabled="isViewMode">
                    </el-input>
                </el-form-item>

                <el-form-item label="审核结果" prop="approvalResult" required>
                    <el-input type="textarea" v-model="form.approvalResult" placeholder="请输入审核结果" :rows="2"
                        resize="vertical" :disabled="isViewMode">
                    </el-input>
                </el-form-item>

                <el-form-item label="审核时间" prop="approvalTime" required>
                    <app-date-picker v-model="form.approvalTime" type="datetime" placeholder="选择审核时间"
                        style="width:200px" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :disabled="isViewMode">
                    </app-date-picker>
                </el-form-item>

                <el-form-item label="附件">
                    <div class="attachment-section">
                        <el-button v-if="!isViewMode" type="primary" @click="handleFileSelect" class="select-file-btn">
                            选取文件
                        </el-button>
                        <input type="file" ref="fileInput" @change="handleFileChange" style="display: none" multiple>

                        <div class="attachment-table" v-if="attachmentList.length > 0">
                            <el-table :data="attachmentList" style="width: 100%" size="small">
                                <el-table-column prop="fileName" label="文件名" align="center" header-align="center">
                                </el-table-column>
                                <el-table-column prop="uploadTime" label="上传时间" align="center" header-align="center" v-if="!isViewMode">
                                </el-table-column>
                                <el-table-column prop="operation" label="操作" align="center" header-align="center"
                                    width="150">
                                    <template slot-scope="scope">
                                        <el-button v-if="isViewMode" type="text" size="small" @click="handleDownloadFile(scope.row)">
                                            下载
                                        </el-button>
                                        <el-button v-if="!isViewMode" type="text" size="small" @click="handleDeleteFile(scope.$index)">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-else style="text-align: center; color: #999; padding: 20px;">
                            暂无附件
                        </div>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button v-if="isViewMode" @click="dialogVisible = false">关闭</el-button>
                <template v-else>
                    <el-button @click="handleSaveDraft">暂存</el-button>
                    <el-button type="primary" @click="handleSubmit">提交</el-button>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { addAbnormalTermination, getBidSectionList, deleteAbnormalTermination, getAbnormalTerminationDetail, getAbnormalTerminationList } from '@/api/abnormalTermination/api'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { getFileDownloadList, getFileList } from '@/api/base/api'
export default {
    name: 'BidTermination',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            tableData: [],
            loading: false,
            searchKeyword: '', // 标段名称搜索
            currentPage: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            isViewMode: false, // 是否为查看模式
            fileGuid: '',
            bidSectionList: [], // 标段列表
            uploadingFiles: [], // 正在上传的文件
            form: {
                bidSectionCode: '',
                bidSectionName: '',
                abnormalType: '',
                abnormalContent: '',
                approvalResult: '',
                approvalTime: ''
            },
            rules: {
                bidSectionCode: [
                    { required: true, message: '请选择标段名称', trigger: 'change' }
                ],
                abnormalType: [
                    { required: true, message: '请选择招标异常类型', trigger: 'change' }
                ],
                abnormalContent: [
                    { required: true, message: '请输入异常情况描述', trigger: 'blur' }
                ],
                approvalResult: [
                    { required: true, message: '请输入审核结果', trigger: 'blur' }
                ],
                approvalTime: [
                    { required: true, message: '请选择审核时间', trigger: 'change' }
                ]
            },
            attachmentList: []
        }
    },
    mounted() {
        this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        this.getProjectInfo()
        this.getList()
        this.getBidSectionList()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        // 获取列表
        async getList() {
            this.loading = true
            try {
                const params = {
                    projectCode: this.projectCode,
                    bidSectionName: this.searchKeyword || '',
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                const response = await getAbnormalTerminationList(params)
                if (response.code === 200) {
                    const data = response.data || {}
                    this.tableData = (data.records || []).map((item, index) => ({
                        no: (this.currentPage - 1) * this.pageSize + index + 1,
                        id: item.id,
                        guid: item.guid,
                        bidSectionCode: item.bidSectionCode,
                        bidSectionName: item.bidSectionName,
                        abnormalType: item.abnormalType,
                        abnormalTypeText: this.getAbnormalTypeText(item.abnormalType),
                        approvalResult: item.approvalResult,
                        approvalTime: item.approvalTime,
                        status: item.status,
                        statusText: this.getStatusText(item.status)
                    }))
                    this.total = data.total || 0
                } else {
                    this.$message.error(response.msg || '获取列表失败')
                }
            } catch (error) {
                console.error('获取列表失败:', error)
                this.$message.error('获取列表失败')
            } finally {
                this.loading = false
            }
        },
        // 获取标段列表
        async getBidSectionList() {
            try {
                const response = await getBidSectionList(this.projectCode)
                if (response.code === 200) {
                    this.bidSectionList = response.data || []
                } else {
                    this.$message.error(response.msg || '获取标段列表失败')
                }
            } catch (error) {
                console.error('获取标段列表失败:', error)
            }
        },

        // 标段选择变化
        handleSectionChange(bidSectionCode) {
            const section = this.bidSectionList.find(item => item.bidSectionCode === bidSectionCode)
            if (section) {
                this.form.bidSectionName = section.bidSectionName
            }
        },

        // 获取异常类型文本
        getAbnormalTypeText(type) {
            const map = {
                1: '重新招标',
                2: '终止招标',
                3: '变更招标方式',
                4: '重新评标'
            }
            return map[type] || '-'
        },

        // 获取状态文本
        getStatusText(status) {
            const map = {
                0: '暂存',
                1: '提交'
            }
            return map[status] || '-'
        },
        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 添加异常信息
        handleAdd() {
            this.isViewMode = false // 设置为编辑模式
            this.resetForm()
            this.dialogVisible = true
        },

        // 重置表单
        resetForm() {
            this.form = {
                bidSectionCode: '',
                bidSectionName: '',
                abnormalType: '',
                abnormalContent: '',
                approvalResult: '',
                approvalTime: ''
            }
            this.attachmentList = []
            this.uploadingFiles = []
            // 重新生成 fileGuid
            this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
            if (this.$refs.terminationForm) {
                this.$refs.terminationForm.clearValidate()
            }
        },

        // 选择文件
        handleFileSelect() {
            this.$refs.fileInput.click()
        },

        // 文件选择变化
        async handleFileChange(event) {
            const files = event.target.files
            if (!files || files.length === 0) return

            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                await this.uploadFile(file)
            }
            // 清空input值，允许重复选择同一文件
            event.target.value = ''
        },

        // 上传文件
        async uploadFile(file) {
            const uploadItem = {
                fileName: file.name,
                uploadTime: new Date().toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                }),
                uploading: true,
                progress: 0
            }
            this.attachmentList.push(uploadItem)
            const index = this.attachmentList.length - 1

            try {
                const result = await doFileUpload(file, {
                    fileBindId: this.fileGuid,
                    onProgress: (progress) => {
                        this.$set(this.attachmentList[index], 'progress', progress)
                    }
                })

                if (result.success) {
                    this.$set(this.attachmentList[index], 'uploading', false)
                    this.$set(this.attachmentList[index], 'fileGuid', result.fileGuid)
                    this.$set(this.attachmentList[index], 'uploadFileId', result.uploadFileId)
                } else {
                    this.$message.error(`文件 ${file.name} 上传失败`)
                    this.attachmentList.splice(index, 1)
                }
            } catch (error) {
                console.error('文件上传失败:', error)
                this.$message.error(`文件 ${file.name} 上传失败`)
                this.attachmentList.splice(index, 1)
            }
        },

        // 删除文件
        handleDeleteFile(index) {
            this.attachmentList.splice(index, 1)
        },

        // 暂存
        async handleSaveDraft() {
            await this.submitForm(0)
        },

        // 提交
        async handleSubmit() {
            await this.submitForm(1)
        },

        // 提交表单
        async submitForm(status) {
            // 检查是否有文件正在上传
            const uploading = this.attachmentList.some(item => item.uploading)
            if (uploading) {
                this.$message.warning('请等待文件上传完成')
                return
            }

            this.$refs.terminationForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息')
                    return
                }

                try {
                    const params = {
                        projectCode: this.projectCode,
                        bidSectionCode: this.form.bidSectionCode,
                        bidSectionName: this.form.bidSectionName,
                        abnormalType: this.form.abnormalType,
                        abnormalContent: this.form.abnormalContent,
                        approvalResult: this.form.approvalResult,
                        approvalTime: this.form.approvalTime,
                        fileGuid: this.fileGuid,
                        status: status
                    }

                    const response = await addAbnormalTermination(params)
                    if (response.code === 200) {
                        this.$message.success(status === 0 ? '暂存成功' : '提交成功')
                        this.dialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(response.msg || '操作失败')
                    }
                } catch (error) {
                    console.error('提交失败:', error)
                    this.$message.error('操作失败')
                }
            })
        },

        // 删除
        handleDelete(row) {
            console.log(row);

            this.$confirm(`确定要删除标段「${row.bidSectionName}」的异常信息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await deleteAbnormalTermination({ guid: row.guid })
                    if (response.code === 200) {
                        this.$message.success('删除成功')
                        this.getList()
                    } else {
                        this.$message.error(response.msg || '删除失败')
                    }
                } catch (error) {
                    console.error('删除失败:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => { })
        },

        // 查看详情
        async handleViewDetail(row) {
            try {
                const response = await getAbnormalTerminationDetail({ guid: row.guid })
                if (response.code === 200) {
                    const detail = response.data || {}
                    // 设置为查看模式
                    this.isViewMode = true
                    // 填充表单数据
                    this.form = {
                        bidSectionCode: detail.bidSectionCode || '',
                        bidSectionName: detail.bidSectionName || '',
                        abnormalType: detail.abnormalType || '',
                        abnormalContent: detail.abnormalContent || '',
                        approvalResult: detail.approvalResult || '',
                        approvalTime: detail.approvalTime || ''
                    }
                    // 获取附件列表
                    await this.getFileDownloadList(detail.fileGuid)
                    this.dialogVisible = true
                } else {
                    this.$message.error(response.msg || '获取详情失败')
                }
            } catch (error) {
                console.error('获取详情失败:', error)
                this.$message.error('获取详情失败')
            }
        },

        /**
         * 获取文件下载列表
         */
        async getFileDownloadList(fileGuid) {
            if (!fileGuid) {
                this.attachmentList = []
                return
            }
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    // 将接口返回的数据转换为附件列表格式
                    this.attachmentList = (res.data || []).map(file => ({
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileUrl: file.fileUrl,
                        fileSize: file.fileSize,
                        fileExtension: file.fileExtension,
                        uploadTime: '', // 查看模式不显示上传时间
                        uploading: false,
                        progress: 100
                    }))
                } else {
                    this.attachmentList = []
                    this.$message.error(res.msg || '获取附件列表失败')
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.attachmentList = []
                this.$message.error('获取文件下载列表失败，请重试')
            }
        },

        // 下载文件
        handleDownloadFile(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank')
            } else {
                this.$message.warning('文件下载链接不存在')
            }
        },

        // 分页 - 每页数量变化
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getList()
        },

        // 分页 - 当前页变化
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 跳转页面
        handleJumpPage() {
            if (this.jumpPage && this.jumpPage > 0) {
                this.currentPage = this.jumpPage
                this.getList()
                this.loadData()
            }
        },

        // 加载数据
        loadData() {
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;

        .table-container {
            .termination-table {
                .el-table__header {
                    th {
                        background-color: #f8fafc;
                        color: #64748b;
                        font-weight: 500;
                        border-color: #e2e8f0;
                    }
                }

                .el-table__body {
                    td {
                        color: #1f2937;
                        border-color: #e2e8f0;
                    }
                }
            }

            .pagination-section {
                display: flex;
                justify-content: flex-end;
                border-radius: 8px;
            }
        }
    }

    // 弹窗样式
    .termination-dialog {
        .el-dialog__header {
            background-color: #f8fafc;
            border-bottom: 1px solid #e2e8f0;
        }

        .el-dialog__body {
            padding: 20px;
        }

        .attachment-section {
            .select-file-btn {
                margin-bottom: 15px;
            }

            .attachment-table {
                .el-table__empty-text {
                    color: #999;
                }
            }
        }

        .dialog-footer {
            text-align: right;
            padding: 10px 0;
        }
    }
}
</style>
